export default __webpack_public_path__ + "static/media/reportsIcon.7d98ad39.svg";